import { jsx as _jsx } from "react/jsx-runtime";
import HomePage from '../Components/Home/HomePage';
import OrganisationsPage from '../Components/Organisations/OrganisationsPage';
export var GlobalRoutes;
(function (GlobalRoutes) {
    GlobalRoutes["Home"] = "/";
    GlobalRoutes["NotFound"] = "/404";
    GlobalRoutes["Oauth2Callback"] = "/oauth2-callback";
    GlobalRoutes["Logout"] = "/logout";
    GlobalRoutes["Organisations"] = "/organisations";
})(GlobalRoutes || (GlobalRoutes = {}));
export const ORGANISATION_ID_PARAM = 'organisationId';
export const LEARN_PROJECT_ID_PARAM = 'learnProjectId';
export function getOrganisationRoute(subRoute) {
    return `/:${ORGANISATION_ID_PARAM}${subRoute}`;
}
export function getOrganisationLink(organisationId, subRoute) {
    if (typeof subRoute == 'string') {
        return `/${organisationId}${subRoute}`;
    }
    else {
        return subRoute(organisationId);
    }
}
export const HomeShowOrgChooserQueryParam = 'showOrgChooser';
export const FROM_ORG_SWITCHER_QUERY_PARAM = 'fromOrgSwitcher';
export const LAST_AUTHORISED_ORG_ID_KEY = 'lastAuthorisedOrgId';
export const OrganisationRouteDefinitions = [
    // Home page will try to find an organisation in local storage and redirect to it
    // If no organisation is found, it will redirect to the organisations page
    {
        path: GlobalRoutes.Home,
        exact: true,
        component: _jsx(HomePage, { pageTitle: "Loading" }),
    },
    // Organisation list page
    {
        path: GlobalRoutes.Organisations,
        component: _jsx(OrganisationsPage, {}),
    },
];
//# sourceMappingURL=NavigationUtils.js.map